import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const LOCALITYTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.LocalityType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('rangeOfInhabitants', 'Entity.LocalityType.RangeOfInhabitants')
    .decimal()
    .build(),
];

export const LOCALITYTYPE_CONFIG = {
  entityName: 'LocalityType',
  localizationKey: 'Planning::Entity.LocalityType',
  fields: LOCALITYTYPE_FIELDS,
  permission: 'PlanningGeography.LocalityTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Geography + MENU_NAME_SUFFIX,
};
